<template>
  <div class="confirm-pay" id="confirmPay">
    <div class="page-header-container">
      <page-header></page-header>
    </div>
    <logo-header title="我的收银台"></logo-header>
    <div class="order-detail-about">
      <div class="order-detail">
        <div class="left">
          <i class="icon-order-done"></i>
          <div class="desc-ordernum">
            <span class="desc">订单提交成功，请尽快付款</span>
            <div class="order-num">
              订单号：
              <span v-if="isPackage" class="package-tip">套餐</span>
              {{ preOrderCode }}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="payable-amount">
            应付金额:
            <span class="amount">￥{{ orderTotal }}</span>
          </div>
          <div
            class="detail-btn-container"
            @click="showOrderDetail = !showOrderDetail"
          >
            <span class="detail-btn">订单详情</span>
            <i class="icon" :class="showOrderDetail ? 'up' : 'down'"></i>
          </div>
        </div>
      </div>
      <div v-show="showOrderDetail" class="order-address-commodity">
        <p class="row address">
          <span class="desc">收货地址：</span>
          <span class="content">{{ orderDetail.addressInfo }}</span>
        </p>
        <p class="row commodity">
          <span class="desc">商品名称：</span>
          <span class="content">{{ orderDetail.goodsInfo }}</span>
        </p>
      </div>
    </div>
    <div class="container" v-loading="loading">
      <div class="pay-method-list-container" v-if="hasPayList">
        <div class="pay-method-list" v-show="!loading">
          <p class="desc">选择支付方式</p>
          <el-collapse
            class="select-pay-method-container"
            v-model="activePayMethod"
            accordion
            @change="onPayMethodChange"
          >
            <el-collapse-item
              class="onlinePay"
              v-show="alipayOnlinePay"
              :name="onlinePay"
            >
              <!-- v-show="!!activePayMethodList.onlinePay" -->
              <template slot="title">
                <div class="el-radio-container" @click="selectedPayMethod">
                  <el-radio :label="onlinePay" v-model="payMethod">
                    <svg
                      t="1569311760873"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2533"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M896 650.666667l-247.04-83.072s18.986667-28.416 39.253333-84.138667c20.266667-55.722667 23.168-86.314667 23.168-86.314667l-159.914666-1.322666v-54.613334l193.664-1.365333V301.226667h-193.706667V213.333333h-94.848v87.893334H275.882667v38.613333l180.693333-1.28v58.581333H311.637333v30.592h298.325334s-3.285333 24.832-14.72 55.722667c-11.434667 30.890667-23.210667 57.941333-23.210667 57.941333s-140.074667-49.024-213.888-49.024-163.584 29.653333-172.288 115.712c-8.661333 86.016 41.813333 132.608 112.938667 149.76 71.125333 17.237333 136.789333-0.170667 193.962666-28.16 57.173333-27.946667 113.28-91.477333 113.28-91.477333l287.914667 139.818667A142.08 142.08 0 0 1 753.792 896H270.208A142.08 142.08 0 0 1 128 753.792V270.208A142.08 142.08 0 0 1 270.208 128h483.584A142.08 142.08 0 0 1 896 270.208v380.458667z m-359.68-48s-88.789333 108.117333-193.408 108.117333c-104.661333 0-126.634667-51.370667-126.634667-88.32 0-36.906667 21.76-77.056 110.805334-82.858667 89.002667-5.802667 209.28 63.061333 209.28 63.061334z"
                        fill="#02A9F1"
                        p-id="2534"
                      />
                    </svg>
                    <span>支付宝支付</span>
                  </el-radio>
                </div>
              </template>
              <!-- <div class="online-pay-about">
                <el-radio-group class="alipay-wxpay" v-model="onlinePayMethod">
                  <el-radio
                    class="row"
                    v-for="item in onlinePayMethodList"
                    :key="item.id"
                    :label="item.onlinePay"
                  >
                    <div class="radio-content">
                      <i class="icon" :class="item.onlinePay ? 'wxpay-logo': 'alipay-logo'"></i>
                      <div class="pay-desc">{{item.name}}</div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div> -->
            </el-collapse-item>
            <el-collapse-item class="onlinePay" :name="weChatPay" v-show="weChatOnlinePay">
              <template slot="title">
                <div class="el-radio-container" @click="selectedPayMethod">
                  <el-radio :label="weChatPay" v-model="payMethod">
                    <svg
                      t="1603419163980"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2411"
                      width="32"
                      height="24"
                    >
                      <path
                        d="M224.780488 0h574.439024c124.116293 0 224.780488 100.63922 224.780488 224.780488v574.439024c0 124.141268-100.664195 224.780488-224.780488 224.780488H224.780488C100.63922 1024 0 923.36078 0 799.219512V224.780488C0 100.63922 100.614244 0 224.780488 0z"
                        fill="#41B135"
                        p-id="2412"
                      ></path>
                      <path
                        d="M441.806049 490.346146c-20.317659 8.216976-36.46439-5.469659-50.151025-15.010341-13.686634-9.603122-58.830049-45.130927-70.168975-40.073366-11.338927 5.045073-8.216976 6.993171-4.995122 15.010341 3.196878 8.067122 56.09522 127.787707 65.148878 145.270635 9.116098 17.445463 28.072585 10.664585 55.146146-4.995122 24.151415-13.948878 326.88078-189.514927 393.116098-227.914927 27.410732 40.935024 43.045463 87.739317 43.045463 137.503219 0 160.243512-161.579707 290.141659-360.947512 290.141659-49.664 0-96.930341-8.067122-139.950829-22.64039l-105.684293 63.350634 31.094634-97.891903c-88.713366-52.84839-146.469463-137.390829-146.469463-232.96 0-160.243512 161.604683-290.129171 360.972488-290.12917 120.881951 0 227.61522 47.940683 293.126243 121.244097-30.620098 13.411902-343.939122 151.26478-363.282731 159.094634z"
                        fill="#FFFFFF"
                        p-id="2413"
                      ></path>
                    </svg>
                    <span>微信支付</span>
                  </el-radio>
                </div>
              </template>
            </el-collapse-item>
            <el-collapse-item
              class="ebank"
              v-show="!!activePayMethodList.ebank"
              :name="ebank"
            >
              <template slot="title">
                <div class="el-radio-container" @click="selectedPayMethod">
                  <el-radio :label="ebank" v-model="payMethod">
                    <svg
                      t="1571813606214"
                      class="ebank"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2457"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="28"
                      height="28"
                    >
                      <path
                        d="M465.556568 2.165654L489.339388 0h47.29001l21.656541 2.165654V316.185496l-2.20503 2.165654-2.165654 4.449434h-2.165654l-2.126279 2.126279-6.496962 2.165654h-60.283934l-6.378836-2.165654-2.283781-2.126279h-4.331308v-4.449434l-2.126279-2.165654-2.165654-8.623241V2.165654z m217.707299 507.51119v152.777051l-2.165654 4.252557-2.165654 2.126279-2.165655 4.331308h-4.213181l-4.331308 2.165654-8.662617 2.165654h-90.406214v241.017612l19.333385-4.41006 19.451511-2.165654 17.325233-6.378835 17.285857-4.331309 8.505114-2.126278 8.54449-4.410059 17.285857-6.496963 17.285857-8.62324 15.120203-8.505115 17.167731-8.662616 15.120203-8.505114 12.875798-10.631393 15.120203-10.82827 28.114127-23.704069 12.954549-12.954548 10.788895-12.954549 12.993925-14.962701 10.788894-12.954549 10.788895-14.962701 8.662617-15.120203 8.544489-17.167731 8.662617-15.080827 8.505114-17.246482 6.457587-17.285857 10.82827-34.492963 6.457587-17.167731 2.165654-19.412135 4.331308-17.246482 2.165654-19.294009 2.165654-38.706145-2.165654-30.082904-2.165654-15.120203v-15.198954l-6.496962-30.004153L905.656853 391.117127l-4.331308-12.915174-4.331308-12.954549-10.670769-27.956625-15.474582-25.515343-12.993925-25.790971-17.246481-21.459663-19.372761-23.704068-19.412135-21.459663-21.499039-19.412136-21.499039-17.167731-23.782819-17.246481-25.830347-15.080828-25.909098-12.993924v352.922864l-2.165654 4.173806-2.165654 2.165654-2.165654 4.213181-4.213182 2.165655h-4.331308l-8.662616 2.126278h-127.143582l-2.126279 2.165654-2.165654 2.165654V361.270476l2.165654-4.410059 2.126279-4.213182 4.331308-2.165654h58.275782l8.505115-2.165654 6.457586-2.126278 4.331308-2.165655 4.449435-6.378835V10.670768L661.764828 23.625317l21.617165 6.457587 19.294009 6.378836 21.538415 8.505114 19.294009 10.907021 19.490886 8.386988 17.285858 10.907021 19.294009 12.954549 17.325232 10.631393 17.285857 12.993925 15.002077 14.9627 17.325232 15.080828 15.080828 15.002076 27.956625 30.319157 12.993925 17.010229 12.993924 17.285857 10.670769 19.294009 10.788894 17.246482 21.499039 38.706144 8.662616 19.451512 6.496963 21.420287 12.954549 40.911175 6.378835 21.420287 4.331308 21.57779 2.126279 21.459663 4.331308 23.743444v70.954703l-2.165654 25.987849-2.165654 25.790971-4.331308 25.751596-6.457587 23.743444-6.378836 25.790971-8.662616 23.625317-8.623241 21.656541-10.710143 23.507191-10.907022 21.459663-12.836422 21.577789-12.993925 21.459664-15.120203 19.294009-15.120203 19.294009-15.002076 19.530262-17.167731 17.246482-17.325232 17.285857-19.412136 14.962701-19.333385 15.002076-19.333384 15.080828-21.499039 12.993924-21.499039 12.915173-21.65654 10.631393-23.625318 10.710144-21.499038 8.662616-25.948474 8.465739-23.625317 6.615089-23.782819 6.457587-25.948474 4.213181-25.909098 2.126279-25.830347 2.165654-25.830346 2.165654-25.909098-2.165654-25.830347-2.047528-25.948474-2.126278-25.909097-4.213182-25.830347-6.496962-23.78282-6.575713-23.743444-8.505115-23.664692-8.662616-21.617166-10.631393-21.499038-10.670768-21.617165-12.954549-21.499039-12.954549-19.451511-15.080827-19.294009-14.962701-19.490887-15.002077-17.167731-17.285857-17.16773-17.325232-17.285857-19.451512-15.002077-19.294009-12.993924-19.294009-12.836423-21.459663-12.993924-21.57779-10.631393-21.577789-10.946397-23.507191-8.54449-21.656541-8.662616-23.625317-6.457587-25.790971-6.378835-23.743444-4.331308-25.869723-4.41006-25.751595L0.019692 537.475967v-49.298162l2.165654-21.459663 2.165654-23.743444 4.331309-21.459663 4.331308-21.57779 4.331308-21.459663 12.915173-40.871799 8.54449-21.459663 8.54449-19.412136 8.662616-19.294009 10.631393-19.412135 10.82827-17.246482 12.875798-19.294009 12.954549-17.285857 12.836423-17.010228 12.993924-15.23833 14.962701-15.080828 15.159578-14.9627 15.002077-15.120204 34.492963-25.790971 17.285857-12.836422 17.285857-12.915174 19.451511-10.907021 19.215259-8.386988 19.451511-10.907021 19.451511-8.54449 19.294009-6.33946 21.538414-6.457587 21.57779-6.496962 21.499039-6.33946V337.842036l2.165654 4.331309 2.165654 2.126278 6.496962 2.165654 6.378836 2.165654 6.457586 2.165654h58.275783l4.291932 2.165654 4.331309 4.173807v152.816427l-4.331309-4.331309H363.849578l-8.623241-2.126278h-4.331308l-2.165654-2.165654-4.331308-4.173806-2.126279-2.165654v-4.567562l-2.165654-6.457586V137.617473l-25.948474 12.915173-23.625317 15.120203-23.113435 17.128355-23.625317 17.285857-21.538415 19.412136-19.451511 21.459663-17.403983 23.625317-17.285858 23.625318-15.002076 23.585941-12.993924 25.751596-6.457587 12.993925-4.213182 14.962701-10.788895 28.035376-6.496962 28.035377-6.378836 29.964777-2.165654 15.238329v15.080828l-2.126278 30.082904v19.294009l2.126278 19.451511 2.165654 17.246482 2.165655 19.294009 4.331308 19.412136 4.331308 17.16773 6.378836 17.246482 2.244405 8.662616 4.449434 8.583865 6.378836 17.246482 6.457587 17.285857 17.325232 32.248558 21.459664 27.91725 10.710143 15.198954 10.788895 15.002076 12.875798 12.718296 12.954549 12.954549 25.830347 23.704068 15.120203 10.788895 15.002076 10.670768 30.161655 17.285858 17.285858 8.505114 15.002076 8.623241 17.325233 6.457586 17.246481 6.496963 19.333385 4.331308 17.325232 6.300084 17.246482 2.165654 19.333385 4.449435v-241.135738H364.322084l-8.662616-2.165654-2.126279-2.165654h-4.331308l-4.331308-4.331308-2.165654-2.126279v-4.213181l-2.165654-6.457587v-146.35884l2.165654 2.244405 2.165654 2.165654 6.496962 4.449435 6.378836 2.126278 6.457586 2.165654h122.85165l4.331308 2.165654 4.331308 4.331309v146.319464h32.406061v-142.263785l2.165654-4.331308 2.126278-4.291933 4.331308-2.165654h122.85165l6.457587-2.126278 6.496962-2.165654 6.378836-4.449435 4.331308-4.173806z"
                        fill="#009174"
                        p-id="2458"
                      />
                    </svg>
                    <span>农行支付</span>
                  </el-radio>
                </div>
              </template>
            </el-collapse-item>
            <el-collapse-item
              :name="offlinePay"
              v-show="!!activePayMethodList.offlinePay"
            >
              <template slot="title">
                <div class="el-radio-container" @click="selectedPayMethod">
                  <el-radio :label="offlinePay" v-model="payMethod">
                    线下支付（带
                    <i class="required-icon"></i>的为必填选项）
                  </el-radio>
                </div>
              </template>
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <div class="offline-pay-about">
                  <div class="time-container row">
                    <div class="icon-desc">
                      <i class="required-icon"></i>
                      <span class="offline-desc">付款时间：</span>
                    </div>
                    <el-date-picker
                      v-model="completedPayTime"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择付款日期"
                    ></el-date-picker>
                  </div>
                </div>
                <el-tab-pane label="银行转账" name="1">
                  <div class="offline-pay-about">
                    <div class="bank-account-container row">
                      <div class="icon-desc">
                        <i class="required-icon"></i>
                        <span class="offline-desc">收款账号：</span>
                      </div>
                      <div class="account-list-container">
                        <ul
                          class="bank-account-list"
                          :class="
                            isShowMoreReceiptAccount ? '' : 'hide-more-account'
                          "
                        >
                          <li
                            v-for="item in dbReceiptAccounts"
                            :key="item.id"
                            class="bank-account"
                          >
                            <el-radio
                              class="bank-num"
                              v-model="selectedReceiptAccountId"
                              :label="item.id"
                              >{{ item.bankNum }}</el-radio
                            >
                            <span class="name">{{ item.name }}</span>
                            <span class="bank">{{ item.bank }}</span>
                          </li>
                        </ul>
                        <div
                          class="show-more-btn"
                          v-show="dbReceiptAccounts.length > 3"
                          @click="showMoreReceiptAccount"
                        >
                          <svg
                            width="14px"
                            height="14px"
                            viewBox="0 0 14 14"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="42支付界面-线下支付-copy"
                                transform="translate(-513.000000, -578.000000)"
                                fill-rule="nonzero"
                              >
                                <g
                                  id="jiantou"
                                  transform="translate(512.000000, 577.000000)"
                                >
                                  <rect
                                    id="矩形"
                                    fill="#000000"
                                    opacity="0"
                                    x="0"
                                    y="0"
                                    width="16"
                                    height="16"
                                  />
                                  <path
                                    d="M14.2599531,6.53996875 C14.0916406,6.53996875 13.9422969,6.607875 13.8234375,6.70965625 L13.8167969,6.70301562 L13.781875,6.73792187 C13.7811875,6.738625 13.7808281,6.73890625 13.780125,6.73957812 L8.181125,12.338625 C8.083375,12.4361094 7.92523437,12.4361094 7.827875,12.338625 L2.19215625,6.70301562 L2.18185938,6.7133125 C2.06239063,6.60884375 1.9106875,6.53998437 1.73970313,6.53998437 C1.36571875,6.53998437 1.06198438,6.84375 1.06198438,7.21804687 C1.06198438,7.4569375 1.1930625,7.65685937 1.38003125,7.77760937 C1.391375,7.798625 1.38903125,7.82421875 1.40667188,7.84185938 L7.82789063,14.2629219 C7.92526563,14.3604844 8.08340625,14.3604844 8.18114062,14.2629219 L14.60225,7.84184375 C14.6222344,7.82185937 14.6205625,7.79329687 14.6321875,7.76932812 C14.8122031,7.64754687 14.9379688,7.45157812 14.9379688,7.21803125 L14.938,7.21803125 C14.9380156,6.84373438 14.63425,6.53996875 14.2599531,6.53996875 Z M1.38001562,2.90153125 C1.39135937,2.92248437 1.38901562,2.94807812 1.40665625,2.96573438 L7.82789063,9.38684375 C7.92526563,9.48432812 8.08340625,9.48432812 8.18114062,9.38684375 L14.60225,2.96573438 C14.6222344,2.94578125 14.6205625,2.91717187 14.6321875,2.89321875 C14.8122031,2.7714375 14.9379688,2.57546875 14.9379688,2.34192188 L14.938,2.3419375 C14.938,1.96764063 14.6342344,1.66390625 14.2599375,1.66390625 C14.091625,1.66390625 13.9422813,1.73179688 13.8234219,1.83354688 L13.8167813,1.82690625 L13.7818594,1.86182813 C13.7811719,1.86253125 13.7808125,1.8628125 13.7801094,1.86353125 L8.18110937,7.4625625 C8.08335938,7.56003125 7.92521875,7.56003125 7.82785938,7.4625625 L2.19214062,1.82689062 L2.18184375,1.8371875 C2.062375,1.73273437 1.9106875,1.66389063 1.7396875,1.66389063 C1.36570312,1.66389063 1.06196875,1.96760938 1.06196875,2.34192187 C1.06196875,2.58082812 1.19304687,2.78078125 1.38001562,2.90153125 Z"
                                    id="形状"
                                    fill="#999999"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="支付宝转账" name="2" v-if="alipayImgList.length>0">
                  <div class="offline-pay-about">
                    <div class="bank-account-container row">
                      <div class="icon-desc">
                        <i class="required-icon"></i>
                        <span class="offline-desc">收款账号：</span>
                      </div>
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="alipayImgList[0].accountCode" 
                        :preview-src-list="[alipayImgList[0].accountCode]">
                      </el-image>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="微信转账" name="3" v-if="weChatImgList.length>0">
                  <div class="offline-pay-about">
                    <div class="bank-account-container row">
                      <div class="icon-desc">
                        <i class="required-icon"></i>
                        <span class="offline-desc">收款账号：</span>
                      </div>
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="weChatImgList[0].accountCode" 
                        :preview-src-list="[weChatImgList[0].accountCode]">
                      </el-image>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="其他转账" name="4" v-if="ortherImgList.length>0">
                  <div class="offline-pay-about">
                    <div class="bank-account-container row">
                      <div class="icon-desc">
                        <i class="required-icon"></i>
                        <span class="offline-desc">收款账号：</span>
                      </div>
                        <el-image
                          v-for="(item,index) in ortherImgList" :key="index"
                          style="width: 100px; height: 100px; margin-right: 20px"
                          :src="item.accountCode" 
                          :preview-src-list="[item.accountCode]">
                        </el-image>
                    </div>
                  </div>
                </el-tab-pane>
                <div class="offline-pay-about">
                  <div class="remark-container row">
                    <div class="offline-desc special">
                      <span class="single-text">备</span>
                      <span class="single-text">注：</span>
                    </div>
                    <el-input
                      class="remark"
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="remark"
                      rows="5"
                      maxlength="150"
                      show-word-limit
                    ></el-input>
                  </div>
                  <div class="upload-voucher-container row">
                    <div class="icon-desc">
                      <!-- <i class="required-icon"></i> -->
                      <span class="voucher-desc">上传凭证：</span>
                    </div>
                    <div class="upload-preview">
                      <div class="upload-container">
                        <el-upload
                          class="upload-voucher"
                          action="#"
                          accept="image/jpeg, image/png, image/jpg"
                          :show-file-list="false"
                          :on-change="imgFileChange"
                          :before-upload="beforeUploadImg"
                          :http-request="uploadImg"
                          :multiple="false"
                        >
                          <el-button class="btn" type="primary"
                            >点击上传</el-button
                          >
                          <div slot="tip" class="tip">
                            (请上传图片，最多五张，单张大小不能超过2MB，支持JPG、JPEG、PNG格式)
                          </div>
                        </el-upload>
                      </div>
                      <div
                        class="preview-container"
                        v-show="voucherImgList.length"
                      >
                        <div
                          class="img-container"
                          v-for="(imgSrc, index) in voucherImgList"
                          :key="index"
                        >
                          <img class="uploaded-img" :src="imgSrc" alt="凭证" />
                          <div class="cover">
                            <i
                              class="delete-btn"
                              @click="removeVoucherImg(index)"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tabs>
            </el-collapse-item>
            <el-collapse-item
              :name="deliveryPay"
              v-show="!!activePayMethodList.deliveryPay"
            >
              <template slot="title">
                <div class="el-radio-container" @click="selectedPayMethod">
                  <el-radio :label="deliveryPay" v-model="payMethod"
                    >货到付款</el-radio
                  >
                </div>
              </template>
              <div class="delivery-desc">请在收货验证无误后支付此订单</div>
            </el-collapse-item>
          </el-collapse>
          <div class="operation">
            <el-button class="btn-red" @click="onOrderSubmit"
              >立即支付</el-button
            >
            <el-button class="btn-white" @click="onReturn">取消</el-button>
          </div>
        </div>
      </div>
      <div class="no-pay-method-container" v-else>
        <div class="no-pay-method" v-show="!loading">
          <img
            class="no-pay-img"
            src="../../../assets/images/no_pay_method.png"
            alt="暂无支付方式"
          />
          <div class="tip">暂无支付方式</div>
        </div>
      </div>
    </div>
    <div ref="formContainer" class="form-container"></div>
    <div class="page-footer-container">
      <page-footer></page-footer>
    </div>
    <Dialog
      title="订单支付"
      content="是否完成支付"
      :dialogVisible="showCancelOrderDialog"
      @confirm="payOver"
      @cancel="cancelPay"
      @hide="toHideCancelOrderDialog"
    ></Dialog>
  </div>
</template>

<script >
import Dialog from "base/xb-base/Dialog";
import PageHeader from "base/xb-base/Header";
import LogoHeader from "base/xb-base/LogoHeader";
import PageFooter from "base/xb-base/Footer";
import { isImage, isImgSizeLt2M, formatTimeToDate } from "common/js/util";
import XbOrder from "models/xb/order.js";
import ImgUploader from "models/img-upload.js";
const xbOrder = new XbOrder();
const imgUploader = new ImgUploader();
// 线上付款
const ONLINE_PAY = 1;
// 线下付款
const OFFLINE_PAY = 2;
// 货到付款
const DELIVERY_PAY = 3;
// 农行支付
const EBANK_PAY = 4;
// 微信支付
const WECHAT_PAY = 5;
export default {
  data() {
    const currTime = this._getCurrTime();
    return {
      // 订单支付完成弹窗
      showCancelOrderDialog: false,
      // 是否为套餐
      isPackage: false,
      // 预订单编号--尚未支付
      preOrderCode: 0,
      // 订单总价
      orderTotal: 0,
      showOrderDetail: false,
      // 订单详情
      orderDetail: {
        addressInfo: "",
        goodsInfo: "",
      },
      // 付款方式
      onlinePay: ONLINE_PAY,
      offlinePay: OFFLINE_PAY,
      deliveryPay: DELIVERY_PAY,
      weChatPay: WECHAT_PAY,
      ebank: EBANK_PAY,
      activePayMethod: OFFLINE_PAY,
      payMethod: OFFLINE_PAY,
      // 已开启的支付方式列表
      activePayMethodList: {
        onlinePay: 0,
        offlinePay: 0,
        deliveryPay: 0,
        weChatPay: 0,
        ebank: 0,
      },
      onlinePayMethod: 0,
      // 线上支付方式列表
      // onlinePayMethodList: [],
      alipayOnlinePay: false,
      weChatOnlinePay: false,
      // 付款日期
      completedPayTime: currTime,
      // 选择的收款账号id
      selectedReceiptAccountId: null,
      // 是否展示更多账户
      isShowMoreReceiptAccount: false,
      // 线下银行卡账号列表
      dbReceiptAccounts: [],
      // 备注
      remark: "",
      // 上传图片文件
      selectedImgFile: null,
      // 已上传的凭证图片列表
      voucherImgList: [],
      // loading状态
      loading: true,
      activeName: '1', //默认是银行转账
      alipayImgList: [], //支付宝转账图片列表
      weChatImgList: [], //微信转账图片列表
      ortherImgList: [], //其他转账图片列表
    };
  },
  computed: {
    // 是否开通了支付方式
    hasPayList() {
      return (
        Boolean(this.activePayMethodList.onlinePay) ||
        Boolean(this.activePayMethodList.offlinePay) ||
        Boolean(this.activePayMethodList.deliveryPay) ||
        Boolean(this.activePayMethodList.ebank) ||
        Boolean(this.activePayMethodList.weChatPay)
      );
    },
  },
  methods: {
    // 图片上传
    imgFileChange(file) {
      // 每次进来前清空
      this.selectedImgFile = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      if (this.voucherImgList.length >= 5) {
        this.$alert("最多上传五张凭证", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      this.selectedImgFile = file.raw;
    },
    beforeUploadImg() {
      return !!this.selectedImgFile;
    },
    // 自定义上传
    uploadImg() {
      if (this.selectedImgFile) {
        imgUploader
          .postImgUpload(this.selectedImgFile)
          .then((res) => {
            if (!res.errorCode) {
              this.voucherImgList.push(res.imgUrl);
            } else {
              this.$message({
                message: "图片上传失败，请重试",
                center: true,
                type: "error",
                duration: 1000,
              });
            }
          })
          .catch((e) => {
            console.log("图片上传失败", e);
          });
      }
    },
    removeVoucherImg(index) {
      this.voucherImgList.splice(index, 1);
    },
    showMoreReceiptAccount() {
      this.isShowMoreReceiptAccount = !this.isShowMoreReceiptAccount;
    },
    // 选择支付方式
    selectedPayMethod(e) {
      // 为了只执行一次
      if (!e.target.classList.contains("el-radio__original")) {
        // 阻止冒泡
        e.stopPropagation();
      }
    },
    onPayMethodChange(payMethod) {
      if (payMethod) {
        this.payMethod = payMethod;
      }
    },
    selectReceiptAccount(index) {
      this.selectedReceiptAccountIndex = index;
    },
    // 点击提交按钮
    onOrderSubmit() {
      let data;
      // 首先判断选择了那种支付方式
      // console.log('当前支付方式--', this.payMethod);
      switch (this.payMethod) {
        // 线上支付
        case ONLINE_PAY:
          // 线上支付判断是支付宝支付还是微信支付
          if (this.onlinePayMethod === 0) {
            // 去请求支付宝支付接口
            data = {
              code: this.preOrderCode,
            };
            this._aliPayWithOrderCode(data);
          } else if (this.onlinePayMethod === 1) {
            // 去请求微信支付接口
          }
          break;
        // 微信支付
        case WECHAT_PAY:
          data = {
            code: this.preOrderCode,
          };
          this._whChatPay(data);
          break;
        // 线下支付
        case OFFLINE_PAY:
          if (
            !this.completedPayTime
            // || !this.voucherImgList.length
          ) {
            this.$message({
              message: "请填写必填项目，不要为空",
              center: true,
              type: "warning",
              duration: 2000,
            });
            return false;
          }
          if (Number(this.activeName) === 1) {
            if (
              !this.selectedReceiptAccountId
            ) {
              this.$message({
                message: "请填写必填项目，不要为空",
                center: true,
                type: "warning",
                duration: 2000,
              });
              return false;
            }
          }
          if (Number(this.activeName) != 1) {
            this.selectedReceiptAccountId = ''
          }
          data = {
            orderCode: this.preOrderCode,
            paymentOfflineId: this.selectedReceiptAccountId,
            message: this.remark,
            paymentTime: this.completedPayTime,
            enclosure: this.voucherImgList,
            type: Number(this.activeName)
          };
          this._offlinePay(data);
          break;
        // 货到付款
        case DELIVERY_PAY:
          data = {
            code: this.preOrderCode,
          };
          this._deliveryPay(data);
          break;
        case EBANK_PAY:
          let orderCode = this.preOrderCode;
          this._eBank(orderCode);
          break;
        default:
          this.$alert("请先选择支付方式", "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true,
          });
          break;
      }
    },
    // 点击返回按钮
    onReturn() {
      this.$router.push({
        path: "/personal/personal-menu/xb-order",
      });
    },
    _getConfirmPayDetail(options) {
      this.loading = true;
      xbOrder
        .getConfirmPayDetail(options)
        .then((res) => {
          if (res.success) {
            console.log("结果", res.result);
            let {
              activePayMethods,
              // 线下支付
              offlinePay = null,
              // 线上支付
              onlinePay = null,
              // 详情
              goodsNameList,
              orderAddress,
              totalPrice,
              setMealId,
            } = res.result;
            this.isPackage = Boolean(setMealId);
            this.activePayMethodList = activePayMethods;
            this.orderTotal = totalPrice;
            this.orderDetail.addressInfo = `${orderAddress.fullAddress}--${orderAddress.receivedName}--${orderAddress.receivedPhone}`;
            let goodsInfo = "";
            goodsNameList.map((item) => {
              goodsInfo += `; ${item}`;
            });
            this.orderDetail.goodsInfo = goodsInfo.substring(2);
            // this.onlinePayMethodList = [];
            if (onlinePay) {
              onlinePay.map((item) => {
                // this.onlinePayMethodList.push({
                //   id: item.id,
                //   onlinePay: item.onlinePay,
                //   name: item.onlinePayName,
                //   status: item.status,
                // });
                if (item.onlinePay == 0) {
                  this.alipayOnlinePay = true
                }
                if (item.onlinePay == 1) {
                  this.weChatOnlinePay = true
                }
              });
            }
            this.dbReceiptAccounts = [];
            this.alipayImgList = [];
            this.weChatImgList = [];
            this.ortherImgList = [];
            if (offlinePay) {
              offlinePay.map(item => {
                if (item.type === 1) {
                  this.dbReceiptAccounts.push({
                    id: item.id,
                    name: item.accountName,
                    bank: item.bankName,
                    bankNum: item.accountCode,
                  });
                }
                if (item.type === 2) {
                  this.alipayImgList.push({
                    id: item.id,
                    accountCode: item.accountCode,
                  })
                }
                if (item.type === 3) {
                  this.weChatImgList.push({
                    id: item.id,
                    accountCode: item.accountCode,
                  })
                }
                if (item.type === 4) {
                  this.ortherImgList.push({
                    id: item.id,
                    accountCode: item.accountCode,
                  })
                }
              });
              // 给默认值
              this.selectedReceiptAccountId = this.dbReceiptAccounts[0].id;
            }
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
          setTimeout(() => {
            this.loading = false;
          }, 1600);
        })
        .catch((e) => {
          setTimeout(() => {
            this.loading = false;
          }, 1600);
        });
    },
    // 支付宝支付
    _aliPayWithOrderCode(options) {
      xbOrder
        .aliPayWithOrderCode(options)
        .then((res) => {
          if (res.success) {
            // 新开页面--支付宝支付
            let html = `
            <body>
              ${res.result}
            <body>
            `;
            let newWindow = window.open(",", "_blank");
            newWindow.document.write(html);
            this.showCancelOrderDialog = true;
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          console.log("异常", e);
        });
    },
    // 微信支付
    _whChatPay(options) {
      xbOrder
        .weChatPay(options)
        .then((res) => {
          if (res.success) {
            // 新开页面--微信支付
             let routeData = this.$router.resolve({
              path: '/weChat-pay',
              query: {
                weChatUrl: JSON.stringify(res.result),
                orderCode: this.preOrderCode,
                orderPrice: this.orderTotal,
                goodsName: this.orderDetail.goodsInfo
              }
             });
            window.open(routeData.href, "_blank");
            this.showCancelOrderDialog = true;
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          console.log("异常", e);
        });
    },
    // 线下支付
    _offlinePay(data) {
      xbOrder
        .offlinePay(data)
        .then((res) => {
          if (res.success) {
            console.log("线下支付提交成功", res.result);
            this.$router.push({
              path: "/personal/personal-menu/xb-order",
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          console.log("线下支付异常", e);
        });
    },
    // 货到付款
    _deliveryPay(data) {
      xbOrder
        .deliveryPay(data)
        .then((res) => {
          if (res.success) {
            console.log("货到付款提交成功", res.result);
            this.$router.push({
              path: "/personal/personal-menu/xb-order",
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          console.log("货到付款异常", e);
        });
    },
    // 农行支付
    _eBank(orderCode) {
      xbOrder.agriculturalBankPay(orderCode).then((res) => {
        if (res.success) {
          let url = res.result;
          window.open(url, "_blank");
          this.showCancelOrderDialog = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取当前时间
    _getCurrTime() {
      const date = new Date();
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let detailDate = date.getDate();
      detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
      return `${year}-${month}-${detailDate}`;
    },
    payOver() {
      this.$router.push({
        path: "/personal/personal-menu/xb-order",
      });
    },
    cancelPay() {
      this.showCancelOrderDialog = false;
    },
    toHideCancelOrderDialog() {
      this.showCancelOrderDialog = false;
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.remark = ''
      this.voucherImgList = []
    },
  },
  created() {
    this.preOrderCode = this.$route.query.orderPreCode;
    this._getConfirmPayDetail({
      code: this.preOrderCode,
    });
  },
  components: {
    PageHeader,
    LogoHeader,
    PageFooter,
    Dialog,
  },
};
</script>

<style lang="scss" scoped>
.confirm-pay {
  position: relative;
  min-height: 100vh;
  .page-header-container {
    width: 1200px;
    margin: 0 auto;
  }
  /* 订单详情 */
  .order-detail-about {
    box-sizing: border-box;
    width: 1200px;
    min-height: 120px;
    padding: 10px 20px 0 20px;
    margin: 0 auto;
    background: #fff;
    .order-detail {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid #e4e4e4;
      .left {
        display: flex;
        align-items: flex-end;
        .icon-order-done {
          margin-right: 24px;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: #df3445;
          background-image: url("../../../assets/secondary-menu/done.png");
          background-size: 56px 56px;
          background-position: center;
          background-repeat: no-repeat;
        }
        .desc-ordernum {
          display: flex;
          flex-direction: column;
          .desc {
            font-size: 24px;
            letter-spacing: 2px;
            margin-bottom: 12px;
          }
          .order-num {
            .package-tip {
              background: #df3445;
              color: #fff;
            }
            font-size: 16px;
          }
        }
      }
      .right {
        display: flex;
        padding-right: 20px;
        flex-direction: column;
        justify-content: flex-end;
        .payable-amount {
          font-size: 16px;
          letter-spacing: 2px;
          margin-bottom: 12px;
          .amount {
            color: #df3445;
            font-size: 20px;
          }
        }
        .detail-btn-container {
          display: flex;
          justify-content: flex-end;
          font-size: 14px;
          color: #3d74f2;
          cursor: pointer;
          .icon {
            margin-left: 6px;
            width: 16px;
            height: 16px;
            background-size: 16px 16px;
          }
          .up {
            background-image: url("../../../assets/secondary-menu/up.png");
          }
          .down {
            background-image: url("../../../assets/secondary-menu/down.png");
          }
        }
      }
    }
    .order-address-commodity {
      padding: 16px 0;
      font-size: 14px;
      .row {
        line-height: 20px;
      }
    }
  }
  /* 支付列表 */
  .pay-method-list-container {
    box-sizing: border-box;
    width: 1200px;
    min-height: 500px;
    padding: 10px 20px 0 20px;
    margin: 0 auto;
    margin-top: 20px;
    background: #fff;
    .pay-method-list {
      min-height: 400px;
      .desc {
        font-size: 16px;
        line-height: 24px;
        padding-bottom: 6px;
        border-bottom: 1px solid #e3e3e3;
      }
      .select-pay-method-container {
        min-height: 10px;
        border-top: none;
        border-bottom: none;
        .required-icon {
          display: inline-block;
          width: 12px;
          height: 12px;
          background-image: url("../../../assets/commodity/required.png");
          background-size: 12px 12px;
          background-position: center;
        }
        .online-pay-about {
          padding-left: 12px;
          .alipay-wxpay {
            width: 100%;
            .row {
              box-sizing: border-box;
              display: flex;
              align-items: center;
              padding: 4px 0;
              width: 100%;
              .radio-content {
                display: flex;
                align-items: center;
                .icon {
                  width: 28px;
                  height: 28px;
                  background-size: 28px 28px;
                }
                .alipay-logo {
                  background-image: url("../../../assets/secondary-menu/alipay.png");
                }
                .wxpay-logo {
                  background-image: url("../../../assets/secondary-menu/wxpay.png");
                }
                .pay-desc {
                  box-sizing: border-box;
                  margin-left: 10px;
                  height: 28px;
                  line-height: 28px;
                  font-size: 14px;
                }
              }
            }
          }
        }
        .offline-pay-about {
          padding-left: 28px;
          .row {
            display: flex;
            margin-bottom: 20px;
            align-items: flex-start;
            &:first-child {
              align-items: center;
            }
            .icon-desc {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .offline-desc {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              width: 76px;
              height: 24px;
              font-size: 14px;
              color: #606266;
            }
            .special {
              width: 88px;
              justify-content: space-between;
            }
            .account-list-container {
              .bank-account-list {
                width: 520px;
                box-sizing: border-box;
                border: 1px solid rgba(234, 238, 245, 0.2);
                background: rgba(234, 238, 245, 0.2);
                padding: 10px 0 0 12px;
                font-size: 14px;
                overflow: hidden;
                position: relative;
                &.hide-more-account {
                  max-height: 140px;
                }
                .bank-account {
                  margin-bottom: 8px;
                  display: flex;
                  align-items: center;
                  .bank-num {
                    flex: 1;
                  }
                  .name {
                    flex: 1;
                  }
                  .bank {
                    flex: 1;
                  }
                }
              }
              .show-more-btn {
                width: 100%;
                text-align: center;
                font-size: 14px;
                cursor: pointer;
              }
            }
            .remark {
              width: 520px;
            }
          }
          .upload-voucher-container {
            .voucher-desc {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              width: 76px;
              height: 24px;
              font-size: 14px;
              color: #606266;
              margin-left: 12px;
            }
            .upload-preview {
              .upload-container {
                .upload-voucher {
                  display: flex;
                  align-items: center;
                  .btn {
                    width: 72px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #fff;
                    color: #3d74f2;
                    border: 1px solid #3d74f2;
                    padding: 0;
                  }
                  .tip {
                    margin-left: 10px;
                    color: #919398;
                    font-size: 14px;
                  }
                }
              }
              .preview-container {
                margin-top: 20px;
                display: flex;
                .img-container {
                  width: 84px;
                  height: 84px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: 10px;
                  position: relative;
                  .uploaded-img {
                    width: 80px;
                    height: 80px;
                  }
                  .cover {
                    width: 84px;
                    height: 84px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: rgba(102, 102, 102, 0);
                    z-index: 99;
                    .delete-btn {
                      width: 16px;
                      height: 16px;
                      background-image: url("../../../assets/offline-pay/delete.png");
                      background-size: 16px 16px;
                      cursor: pointer;
                      display: none;
                    }
                    &:hover {
                      background: rgba(102, 102, 102, 0.5);
                      .delete-btn {
                        display: block;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .delivery-desc {
          padding-left: 20px;
          font-size: 14px;
          color: #919398;
        }
      }
      .operation {
        display: flex;
        justify-content: flex-start;
        margin-top: 20px;
        padding-bottom: 20px;
        .btn-red {
          width: 120px;
          height: 32px;
          font-size: 14px;
          color: #ffffff;
          border: none;
          background: rgba(223, 52, 69, 0.75);
          border-radius: 4px;
          padding: 0;
          &:hover {
            background: rgba(223, 52, 69, 1);
          }
        }
        .btn-white {
          margin-left: 20px;
          width: 120px;
          height: 32px;
          font-size: 14px;
          color: #df3445;
          border: 1px solid #df3445;
          padding: 0;
          &:hover {
            background: #fff;
          }
          &:focus {
            background: #fff;
          }
        }
      }
    }
  }
  /* 无支付方式 */
  .no-pay-method-container {
    box-sizing: border-box;
    width: 1200px;
    min-height: 500px;
    padding: 10px 20px 0 20px;
    margin: 0 auto;
    margin-top: 20px;
    background: #fff;
    .no-pay-method {
      width: 100%;
      min-height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .no-pay-img {
        width: 100px;
        opacity: 0.5;
      }
      .tip {
        font-size: 16px;
        color: #ccc;
      }
    }
  }
  [v-cloak] {
    display: none;
  }
}
</style>

<style lang="scss">
#confirmPay {
  .el-form {
    .el-form-item {
      .el-form-item__label::before {
        content: "";
      }
    }
  }
  .el-radio.is-checked {
    .el-radio__input.is-checked {
      .el-radio__inner {
        border-color: #df3445;
        background: #df3445;
      }
    }
  }
  .el-radio {
    display: flex;
    align-items: center;
    .el-radio__label {
      color: #606266;
      display: flex;
      align-items: center;
      .ebank {
        margin: 0 2px;
      }
    }
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .onlinePay,
  .ebank {
    .el-collapse-item__arrow {
      display: none;
    }
  }
  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #E4E7ED;
  }
  .el-tabs__item.is-active {
    color: #fff;
    background-color: #DF3445;
  }
  .el-tabs__item.is-active:hover {
    color: #fff;
  }
  .el-tabs__item:hover {
    color: #303133;
  }
}
</style>
